'use strict';

angular.module('ClinicApp').controller('ClinicTutorialModal', function(
  $scope,
  $modalInstance,
  OpencareConstants,
  UserService,
  CurrentUser,
) {
  const user = CurrentUser.getUser();

  $scope.finishedFlow = typeof user?.metadata?.publicClinicOnboardingFinished === 'boolean';

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
    pageName: 'Clinic Tutorial',
    name: 'clinic-tutorial',
    practiceId: $scope.$parent?.clinic?.id,
  });

  $scope.close = function() {
    OpencareAnalytics.trackClick({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
      pageName: 'Clinic Tutorial',
      name: 'clinic-tutorial',
      practiceId: $scope.$parent?.clinic?.id,
      content: {
        value: 'close',
      },
    });

    $modalInstance.close();

    if ($scope.finishedFlow !== true && user.metadata?.publicClinicOnboarding === true) {
      UserService.setClinicOnboardingFlag(false);
    }
  };

  $scope.submit = function() {
    OpencareAnalytics.trackClick({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
      pageName: 'Clinic Tutorial',
      name: 'clinic-tutorial',
      practiceId: $scope.$parent?.clinic?.id,
      content: {
        value: 'submit',
      },
    });

    if ($scope.finishedFlow !== true && user.metadata?.publicClinicOnboarding === true) {
      $scope.finishedFlow = true;
      UserService.setClinicOnboardingFlag(true);
    }

    window.open(OpencareConstants.tutorialUrl, '_blank');
  };
});
